module.exports = __webpack_public_path__ + "img/RJMT_heart_green.73af1f38.svg";